import React, { CSSProperties, forwardRef, ReactNode, useMemo } from "react";
import { createPortal } from "react-dom";
import useIsMounted from "../../../hooks/useIsMounted";

export const HIDDEN_PORTAL_BASIC_STYLES: CSSProperties = {
  display: "inline-block",
  position: "absolute",
  visibility: "hidden",
  zIndex: -1,
  top: "-100px",
  left: "-100px",
};

export interface IHiddenPortalProps {
  children?: ReactNode;
  style?: React.CSSProperties;
}

const HiddenPortal = forwardRef<HTMLDivElement, IHiddenPortalProps>(
  ({ style, children }, ref) => {
    const isMounted = useIsMounted();

    const styles = useMemo(
      () => ({ ...HIDDEN_PORTAL_BASIC_STYLES, ...(style || {}) }),
      [style],
    );

    return isMounted()
      ? createPortal(
          <div style={styles} ref={ref}>
            {children}
          </div>,
          document.body,
        )
      : null;
  },
);

export default HiddenPortal;
